/**
 * An enum of categories to which a cookie can belong.
 */
export type Category =
  | 'authentication'
  | 'essential'
  | 'functional'
  | 'advertising';

export type CategoryValue =
  | {necessary: true}
  | {
      necessary: false;
      token: string;
      // List of deprecated tokens, being mapped from the cookie consent version
      // to a list of tokens that are a subset of the active token/category.
      // For example, { "1": ["p", "s"] } means that the "p" and "s" tokens for v1
      // cookie permissions are a subset of the current `functional` token.
      deprecatedTokens?: Record<string, string[]>;
    };

/**
 * The categories in which cookies and local storage items can be defined.
 *
 * An invariant expected by the Permissions class `toString` method is that
 * necessary cookies do not need a token, and not necessary cookies must
 * have a token.
 */
export const Categories: {
  [Property in Category]: CategoryValue;
} = {
  authentication: {necessary: true},
  essential: {necessary: true},
  functional: {
    necessary: false,
    token: 'f',
    deprecatedTokens: {'1': ['p', 's']},
  },
  advertising: {necessary: false, token: 'a'},
};
